import { Component, OnInit } from '@angular/core';
import { ToolsService } from '../../../../services/tools.service';

@Component({
  selector: 'app-tax-lots',
  templateUrl: './tax-lots.component.html',
  styleUrls: ['./tax-lots.component.css']
})
export class TaxLotsComponent implements OnInit {
  entity = '';
  result: any;
  error = '';
  loading = false;
  token: string = '';

  constructor(private toolsService: ToolsService) {}

  ngOnInit(): void {
    const userStr = sessionStorage.getItem('wOSUser') || '{}';
    const parsedUser = JSON.parse(userStr);
    this.token = parsedUser?.stsTokenManager?.accessToken || '';
  }

  async runTaxLots() {
    this.result = null;
    this.error = '';
    this.loading = true;

    if (!this.token) {
      this.error = 'No auth token found in sessionStorage';
      this.loading = false;
      return;
    }

    try {
      const res = await this.toolsService.runTaxLots(this.entity, this.token);
      this.result = res;
    } catch (err: any) {
      this.error = err.message || 'Something went wrong';
    } finally {
      this.loading = false;
    }
  }
}
